export const APPLICATION_URL_HELP_TEXT =
  'Copy this URL and replace the values with values from your CRM. ' +
  'Note: when creating leads, do not include crmId, signerIndex, or pdfOnly. ' +
  'For pdfOnly, a value of 1 equals true and no value equals false. ' +
  'recordOwnerId refers to the CRM record owner who you want to assign to a newly created lead.';
